// extracted by mini-css-extract-plugin
export default {"message":"ErrorMessage_message__+YK8-"};